<template>
  <div class="page splash-screen">
    <div class="content">
      <h1
        class="font-regular text-size-80 line-height-default fg-brand"
        v-html="$getString('SPLASH_SCREEN_HEADING')"
      ></h1>
      
      <div class="lines">
        <div class="line line-root node-start">
          <div class="line line-tail node-start">
            <div class="node-final"></div>
          </div>
        </div>
        <div class="line line-short"></div>
        <div class="line line-long"></div>
      </div>

      <p
        class="font-regular text-size-34 line-height-large fg-grey mt-8"
        v-html="$getString('SPLASH_SCREEN_BODY')"
      ></p>

      <DefaultButton
        :label="$getString('SPLASH_BUTTON_LABEL')"
        buttonClass="centered text-uppercase button-grey"
        @pressed="onClick"
      />
    </div>
    <footer class="fg-grey bg-white">
      <div class="font-semibold text-size-24 line-height-default" v-html="$getString('APPROVAL_CODE')"></div>
      <div class="font-regular text-size-24 line-height-default text-right" v-html="$getString('SPLASH_SCREEN_DISCLAIMER')"></div>
    </footer>
  </div>
</template>

<script>
import DefaultButton from '../partials/DefaultButton'

export default {
  name: 'SplashScreen',
  components: {
    DefaultButton,
  },
  methods: {
    onClick() {
      this.$emit('action', { type: 'navigate', data: 'PresentationScreen' });
    },
    pauseVideo() {
      return 0;
    },
    resumeVideo() {
      return 0;
    },
  },
}
</script>
